import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import {
	BasicSelect
} from 'vue-search-select';
import {
	Validator
} from 'vee-validate'
import moment from 'moment'
export default {
	name: 'bulk-inscan-overage-shipment',
	components: {
		VueElementLoading,
		BasicSelect,
		Paginate
	},
	props: [],
	data() {
		return {
			isLoading: false,
			hubLoading: '',
			opened: [],
			OverageShipmentList: [],
			OverageShipmentDetailsList: [],
			hublist: [],
			hubitem: {
				value: '',
				text: ''
			},
			hub: '',
			shippingID: '',
			shippingIDError: '',
			reason: '',
			reasonError: '',
			hubid: '',
			hubName: '',
			createdbyemail: '',
			pageNo: 0,
			limit: 10,
			pageCount: 0,
			totalRows: 0,
			token: '',
			invalidTokenModal: false,
			invalidtokenmsg: '',
			timeoutHandler: 0,
			inputString:'',
			manualInput:false,
			openBagHubName:'',
			openbagList:'',
			OverageBagList:'',
			ProcessedShipmentIds:[],
			InvalidShipmentIds:[],
			bulkShipmentIds:[],
		}
	},
	computed: {},
	filters: {
		moment: function(date) {
			if (date == null || date == '')
				return '--'
			return moment(date).format('DD-MM-YYYY HH:mm:ss');
		},
	},
	mounted() {
		var userTokenEncrypt = window.localStorage.getItem('userToken')
		var userTokenDecrypt = CryptoJS.AES.decrypt(userTokenEncrypt.toString(), 'Key');
		var userToken = userTokenDecrypt.toString(CryptoJS.enc.Utf8);
		this.token = JSON.parse(userToken)
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext)
		this.hubid = userdetail[0].HubId[0];
		this.createdbyemail = userdetail[0].email;
		this.getLoginHubName(userdetail[0].HubId)
		this.getHubList();
	},
	methods: {
		checkBarcode(e){
			if (this.timeoutHandler) {
      clearTimeout(this.timeoutHandler)
      this.inputString += String.fromCharCode(e.keyCode)
    	}
			this.timeoutHandler = setTimeout(() => {
		 		if (this.inputString.length <= 3) {
			 		this.manualInput = true
			 		this.inputString = ''
		 		}else{
			 		this.manualInput = false
			 		this.inputString = ''
		 		}
	 		}, 10)
 		},
		getLoginHubName(hubid) {
			this.input = {
				hubids: hubid
			}
			axios({
					method: 'POST',
					url: apiUrl.api_url_hubops + 'expose/hubservicecenter/hubarray/get',
					data: this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					if (result.data.ResultCode == 100) {
						this.hubName = result.data.ResponseData[0].HubName;
					} else {
						this.hubName = '';
					}
				}, error => {
					console.error(error)
				})
		},
		getHubList() {
			this.hubLoading = 'Loading Hub...'
			this.input = ({})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'expose/hubservicecenter/dropdwon/list',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					this.hubLoading = ''
					var HubDetails = result.data.ResponseData
					for (var i = 0; i < HubDetails.length; i++) {
						this.hublist.push({
							"value": HubDetails[i].HubID,
							"text": HubDetails[i].HubName + '(' + HubDetails[i].HubID + ')',
						})
					}
					this.hubitem = {
						value: this.hubid,
						text: this.hubName
					}
					this.hub = this.hubitem.text
				}, error => {
					console.error(error)
				})
		},
		logout(e) {
			localStorage.removeItem('permissiondata')
			localStorage.removeItem('userdetail')
			localStorage.removeItem('userToken')
			localStorage.removeItem('isLoggedIn')
			localStorage.removeItem('loginDate')
			this.$router.push('/login')
			e.preventDefault()
		},
		closeinvalidTokenModal() {
			this.invalidTokenModal = false
			this.invalidtokenmsg = ''
		},
		showOverageDetails() {
			 if (this.hub == "") {
				return false;
			} else {
				this.isLoading = true
				this.totalRows = 0
				this.input = {
					"hubId": this.hubitem.value,
					"pageIndex": this.pageNo,
					"pageSize": this.limit
				}
        axios({
            method: 'POST',
            url: apiUrl.api_url_hubops + 'overageShipmentDetailsPendingList',
            data: this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
              'requestfrom': "WEB",
              'token': this.token
            }
          })
          .then((response) => {
            this.isLoading = false
            if (response.data.ResultCode == 100) {
              this.invalidTokenModal = false
              this.OverageShipmentList = response.data.ResponseData
              this.totalRows = response.data.TotalCount
              if (this.totalRows < 10) {
                this.pageCount = 1
              } else {
                this.pageCount = Math.ceil(this.totalRows / 10);
              }
            } else if (response.data.ResultCode == 401) {
              this.invalidTokenModal = true
              this.invalidtokenmsg = result.data.ReturnMessage
              this.$alertify.error(result.data.ReturnMessage)
            } else {
              this.invalidTokenModal = false
              this.$alertify.error(response.data.ReturnMessage)
            }
          })
          .catch((httpException) => {
            this.isLoading = false
            console.error('exception is:::::::::', httpException)
          })
			}
		},
		getPaginationData(pageNum) {
			this.pageNo = (pageNum - 1)
			this.showOverageDetails()
		},
		getShipmentOverageList(data, ind) {
			const index = this.opened.indexOf(ind);
			if (index > -1) {
				this.opened.splice(index, 1)
			} else {
				this.opened = [];
				this.opened.push(ind)
				this.OverageShipmentDetailsList = []
				this.input = {
					"shippingId": data.shippingid
				}
				axios({
						method: 'POST',
						url: apiUrl.api_url_hubops + 'overageShipmentDetailsByShippingId',
						data: this.input,
						headers: {
							'authorization': 'authkey xB84JJ89Hd25',
							'requestfrom': "WEB",
							'token': this.token
						}
					})
					.then((response) => {
						if (response.data.ResultCode == 100) {
							this.invalidTokenModal = false
							this.OverageShipmentDetailsList = response.data.ResponseData.result
							// this.$alertify.success(response.data.ReturnMessage)
						} else if (response.data.ResultCode == 401) {
							this.invalidTokenModal = true
							this.invalidtokenmsg = result.data.ReturnMessage
							this.$alertify.error(result.data.ReturnMessage)
						} else {
							this.invalidTokenModal = false
							this.$alertify.error(response.data.ReturnMessage)
						}
					})
					.catch((httpException) => {
						console.error('exception is:::::::::', httpException)
					})
			}
		},
		UpdateShipmentOverage() {
			if (this.shippingID == '') {
				this.manualInput = false
				this.shippingIDError = "The shipping ID field is required."
				return false;
			} else {
				if(this.shippingID)
				{
					if(/\r?\n|\r/g.test(this.shippingID) == true){
						this.shippingID = this.shippingID.replace(/\r?\n|\r/g,',');
					}
				}
				this.input = {
					"overageShipmentDetailsId": 0, //optional
					"hubId": this.hubid,
					"hubName": this.hubName,
					"shippingId": this.shippingID,
					"comments": "", //optional
					"lastModifiedBy": this.createdbyemail,
					"isShipment": true,
					"status": true,
					"isManualEntry": this.manualInput
				}
				axios({
						method: 'POST',
						url: apiUrl.api_url_hubops + 'bulkOverageShipmentUpdate',
						data: this.input,
						headers: {
							'authorization': 'authkey xB84JJ89Hd25',
							'requestfrom': "WEB",
							'token': this.token
						}
					})
					.then((response) => {
						if (response.data.ResultCode == 100) {
							this.invalidTokenModal = false
							this.$alertify.success(response.data.ReturnMessage)
							this.ProcessedShipmentIds = response.data.ProcessedShipmentIds;
							this.InvalidShipmentIds = response.data.InvalidShipmentIds;
							this.resetForm()
							// this.showOverageDetails();
						} else {
							this.invalidTokenModal = false
							this.$alertify.error(response.data.ReturnMessage)
						}
					})
					.catch((httpException) => {
						console.error('exception is:::::::::', httpException)
					})
			}
		},
		InscanShipmentOverage(OverageShipmentDetailsList) {
			this.input = {
				"overageShipmentDetailsId": 0, //optional
				"hubId": this.hubid,
				"hubName": this.hubName,
				"shippingId": OverageShipmentDetailsList.shippingid,
				"comments": OverageShipmentDetailsList.reason, //optional
				"lastModifiedBy": this.createdbyemail,
				"isShipment": true,
				"status": false,
				"isManualEntry": false
			}
			axios({
					method: 'POST',
					url: apiUrl.api_url_hubops + 'overageBagOrShipmentUpdate',
					data: this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
						'requestfrom': "WEB",
						'token': this.token
					}
				})
				.then((response) => {
					if (response.data.ResultCode == 100) {
						this.invalidTokenModal = false
						this.$alertify.success(response.data.ReturnMessage)
						this.showOverageDetails()
					} else if (response.data.ResultCode == 401) {
						this.invalidTokenModal = true
						this.invalidtokenmsg = result.data.ReturnMessage
						this.$alertify.error(result.data.ReturnMessage)
					} else {
						this.invalidTokenModal = false
						this.$alertify.error(response.data.ReturnMessage)
					}
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})
		},
		resetForm() {
			this.shippingID = ''
		},
		clearID() {
			this.shippingID = ''
			this.manualInput = false
			this.shippingIDError = ''
			this.opened = []
			this.OverageShipmentList = []
			this.OverageShipmentDetailsList = []
			this.isLoading = false,
			this.ProcessedShipmentIds =[]
			this.InvalidShipmentIds =[]
		},
		selectReason(reasonitem) {
			this.reasonitem = reasonitem
			this.reason = this.reasonitem.text
		},
		clearError() {
			if (this.shippingID == '') {
				this.manualInput = false
				this.shippingIDError = "The shipping ID field is required."
			} else {
				this.shippingIDError = ""
			}
		},
		closeList(){
			this.opened = []
		},
		onSubmit: function(event) {
			this.$validator.validateAll().then((result) => {
				if (!result) {
					return false;
				}
			}).catch(() => {
				console.log('errors exist', this.errors)
			});
		},
		onSubmitShipment: function(event) {
			this.$validator.validateAll().then((result) => {
				if (!result) {
					this.shippingIDError = "The shipping ID field is required."
					return false;
					}
					else{
						this.shippingIDError=''
						this.UpdateShipmentOverage()
					}
			}).catch(() => {
				console.log('errors exist', this.errors)
			});
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/components/BulkInscanOverageShipment/BulkInscanOverageShipment.js